import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';

import AddSCModal from './addSCModal';
import PTable from '../common/ptable';

import * as scActions from './actions';
import * as hcActions from '../hiringclients/actions';
import * as registerActions from '../register/actions';
import * as scProfileActions from '../sc-profile/actions';

import Utils from '../../lib/utils';
import FilterSC from './filter';
import * as filterActions from "../certfocus/filterbox/actions";
import * as usersActions from "../users/actions";
import DataTable from "../common/table";
import swal from 'sweetalert2';
import { change, reset } from 'redux-form';
import { PQ_ADMIN_ROLE_ID, PQ_FINANCIAL_ANALYST_ROLE_ID, PQ_OPERATOR_ROLE_ID, PROJECT_INSURED_COMPLIANT_STATUS_ID, PROJECT_INSURED_NON_COMPLIANT_STATUS_ID, SELF_SERVICE_ADMIN_ROLE_ID } from '../../lib/appConstants';

class Subcontractors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        pageNumber: 1
      },
      filterBox: {
        searchTerm: '',
        searchByHCId: '',
        searchByStatusId: [],
        searchByTradeId: [],
        searchByTierRatingId: [],
        searchByStateName: '',
        searchByCountry: [],
        searchByMaxSingleLimit: '',
        searchByMaxAggregateLimit: '',
        searchByVendorId: '',
        searchByArchive: false,
        searchByInsuranceStatusId: []},
      tableOrderActive: 'id',
      showFilterBox: false,
      order: {
        id: 'asc',
        name: 'asc',
        mainTrade: 'desc',
        taxID: 'desc',
        tierDesc: 'desc',
        status: 'desc',
        vendorId: 'desc',
        state: 'desc',
        insuranceStatusId: 'desc'
      },
      hcOption: false,
      selectedSubcontractors: {},
      showInsuranceStatus: false
    };

    this.viewSubcontractor = this.viewSubcontractor.bind(this);

    // props.hcActions.fetchHiringClients({ withoutPag: true });
    props.actions.fetchSCStatusWithCounts(props.hcId, this.props.loginProfile.Id || null);
    props.actions.fetchSCTierRates();
    props.registerActions.fetchResources();
    props.registerActions.fetchGeoStates();

    if (this.props.fromHCtab) {
      props.actions.fetchTrades('tradesbyhc', {
        hiringClientId: props.hcId
      });
    } else {
      props.actions.fetchTrades('tradesbyuserid');
    }
  }
  componentDidMount() {
    let saveFilter = { tab: 'subcontractors' };
    saveFilter.module = this.props.fromHCtab ? 'PQHiringclient' : 'hiringclients';
    saveFilter.objectId = null;

    let filtersApplied = false;
    this.setState({showInsuranceStatus: this.props.hcProfileData && this.props.hcProfileData.hasDualAccess});

    this.props.filterActions
      .fetchDefaultFilters(saveFilter, 'FilterSC', (filters) => {
        if (filters) {
          this.initSavedFilters(this.props.dispatch, 'FilterSC', filters);
          this.setState({
            filterBox: { ...this.state.filterBox, ...filters },
            showFilterBox: true,
          });
          filtersApplied = true;
        }
      })
      .then(() => {
        const { errorHC } = this.props;
        if (errorHC || !filtersApplied) {
          throw new Error(errorHC || 'Failed to load filters: No valid filters returned');
        }
        if (this.props.loginProfile.Id) {
          const query = this.getFetchQuery();
          this.props.actions.fetchSubcontractors(query);
        }
      })
      .catch((error) => {
        if (this.props.loginProfile.Id) {
          const query = this.getFetchQuery();
          this.props.actions.fetchSubcontractors(query);
        }
      });
  }

  componentWillReceiveProps(nextProps) {
    const oldHcOption = this.state.hcOption
    const newHcOption = nextProps.sc && nextProps.sc.list && nextProps.sc.list[0] && nextProps.sc.list[0].hcOption ? nextProps.sc.list[0].hcOption : null

    if (newHcOption && newHcOption != oldHcOption) {
      this.setState({
        hcOption: newHcOption
      }, () => {
        if (this.state.hcOption == 1) {

          const order = this.state.order
          order.requestorName = 'desc'
          order.requestorEmail = 'desc'

          this.setState({
            order
          })
        }
      })
    }

    if (nextProps.loginProfile.Id !== this.props.loginProfile.Id) {
      const field = this.state.tableOrderActive;
      const pageNumber = this.state.filter.pageNumber;
      const orderDirection = this.state.order[field] === 'asc' ? 'ASC' : 'DESC'
      let query = Utils.getFetchQuery(field, pageNumber, orderDirection);
      query.userId = nextProps.loginProfile.Id;
      this.addHCId(query);
      this.props.actions.fetchSubcontractors(query);
    }

    let
      oldHcId = this.props.hcId,
      newHcId = nextProps.hcId,
      hcId = oldHcId ? oldHcId : newHcId

    if (oldHcId !== newHcId) {
      const userId = this.props.loginProfile.Id || null;
      this.props.actions.fetchSCStatusWithCounts(hcId, userId);
    }

  }

  componentWillUnmount() {
    this.props.dispatch(reset('FilterSC'));
  }

  initSavedFilters(dispatch, formName, values) {
    const filterBoxMap = {
      keywords: "searchTerm",
      status: "searchByStatusId",
      trade: "searchByTradeId",
      tierRating: "searchByTierRatingId",
      stateId: "searchByStateName",
      countryId: "searchByCountry",
      vendorId: "searchByVendorId",
      archived: "searchByArchive",
      ...(this.state.showInsuranceStatus && { insuranceStatusId: "searchByInsuranceStatusId" })
    };

    const statusWithCounts = this.props.sc.subcontratorStatusWithCounts || [];
    const reconstructedStatus = values.searchByStatusId.map((status) => {
      const matchingStatus = statusWithCounts.find((s) => s.Id === status.value);
      return {
        value: status.value,
        label: matchingStatus
          ? `${matchingStatus.Status} (${matchingStatus.SubCount || 0})`
          : status.label,
        plainLabel: status.label
      };
    });

    Object.entries(filterBoxMap).forEach(([originalKey, mappedKey]) => {
      let value = values[mappedKey];
      if (mappedKey === "searchByStatusId") {
        value = reconstructedStatus;
      }
      if (mappedKey === "searchByInsuranceStatusId" && Array.isArray(value)) {
        value = value.map(item => ({ value: item.value, label: item.plainLabel || item.label }));
      }
      dispatch(change(formName, originalKey, value));
    });
  }
  
  onChangeSelectedSubcontractors(e, subcontractorId) {
    this.props.setSelectedSubcontractors({
      [subcontractorId]: e.target.checked
    })
  }

  archiveSelectedSubcontractors() {
    const subcontractorIds = Object.keys(this.props.sc.selectedSubcontractors);
    const subcontractorLength = subcontractorIds.length;
    swal({
      title: 'Are you sure?',
      type: 'warning',
      text: `Do you want to archive ${subcontractorLength} subcontractor${subcontractorLength > 1 ? 's' : ''}?`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#2E5965',
      cancelButtonColor: '#aaa',
    }).then((result) => {
      if (result.value) {
        swal({
          title: 'Archiving...',
          text: 'Please wait while the subcontractors are being archived.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            swal.showLoading();
          },
        });

        this.props.actions.setArchiveSubcontractors({
            hiringClientId: this.props.hcId,
            subcontractorIds
          })
          .then(() => {
            swal.close();
            window.location.reload();
          })
          .catch((error) => {
            swal.close();
            swal({
              type: 'error',
              title: 'Error',
              text: 'Failed to archive subcontractors. Please try again.',
            });
          });
      }
    });

  }

  addHCId(query) {
    const { SCPerPageFromHCTab } = this.props.sc;

    if (this.props.fromHCtab) {
      query.searchByHCId = this.props.hcId;
      query.pageSize = SCPerPageFromHCTab;
    }

    query.hasDualAccess = this.props.hcProfileData && this.props.hcProfileData.hasDualAccess || false;
    return query;
  }

  renderAssignSCUser() {
    let { assignSCUser } = this.props.local.strings.subcontractors;

    let component = '';
    if (this.props.loginProfile.Role && (this.props.loginProfile.Role.Name != 'Subcontractor')) {
      component =
        <a
          className='cell-table-link icon-add'
          onClick={(e) => { /*this.openAddHCUserModal(e, sc.id) */ }}>
          {assignSCUser}
        </a>
    }
    return component;
  }

  viewSubcontractor(scId) {
    if (this.props.fromHCtab) {
      this.props.scProfileActions.setHiringClientId(this.props.hcId);
    }
    this.props.history.push(`/subcontractors/${scId}`);
  }

  clickOnColumnHeader = (e, field) => {
    if (field === 'assignSCUser' || field === 'view' || field === 'singleProjectLimit') return;
    // get base query
    const pageNumber = this.state.filter.pageNumber;
    const orderDirection = this.state.order[field] === 'asc' ? 'DESC' : 'ASC'
    let query = Utils.getFetchQuery(field, pageNumber, orderDirection);
    query.userId = this.props.loginProfile.Id;
    // add search filters
    const filterBox = {
      ...this.state.filterBox,
      searchByStatusId: this.state.filterBox.searchByStatusId.map((item) => item.value),
      searchByTradeId: this.state.filterBox.searchByTradeId.map((item) => item.value),
      searchByTierRatingId: this.state.filterBox.searchByTierRatingId.map((item) => item.value),
      searchByCountry: this.state.filterBox.searchByCountry.map((item) => item.value),
      ...(this.state.showInsuranceStatus 
          && { searchByInsuranceStatusId: Array.isArray(this.state.filterBox.searchByInsuranceStatusId) 
              ? this.state.filterBox.searchByInsuranceStatusId.map((item) => item.value)
              : ''
            }
      )
    };
    query = Utils.addSearchFiltersToQuery(query, filterBox);
    this.addHCId(query);
    const sortQuery = { ...query };
    // save new active tab and order
    let newState = {
      tableOrderActive: field,
      order: {
        name: field === 'name' ? 'asc' : 'desc',
        mainTrade: field === 'mainTrade' ? 'asc' : 'desc',
        taxID: field === 'taxID' ? 'asc' : 'desc',
        tierDesc: field === 'tierDesc' ? 'asc' : 'desc',
        status: field === 'status' ? 'asc' : 'desc',
        vendorId: field === 'vendorId' ? 'asc' : 'desc',
        state: field === 'state' ? 'asc' : 'desc'
      }
    };

    if (this.state.showInsuranceStatus) {
      newState.order.insuranceStatusId = field === 'insuranceStatusId' ? 'asc' : 'desc';
    }

    if (this.state.hcOption == 1) {
      newState.order.requestorName = field === 'requestorName' ? 'asc' : 'desc'
      newState.order.requestorEmail = field === 'requestorEmail' ? 'asc' : 'desc'
    }

    newState.order[field] = this.state.order[field] === 'asc' ? 'desc' : 'asc';
    
    this.setState(newState, () => {
      this.props.actions.fetchSubcontractors(sortQuery);
    });
  }

  setPageFilter = (e, pageNumber, force) => {
    // if (this.state.filter.pageNumber !== pageNumber || force) {
      // get base query
      const field = this.state.tableOrderActive;
      const orderDirection = this.state.order[field] === 'asc' ? 'ASC' : 'DESC'
      let query = Utils.getFetchQuery(field, pageNumber, orderDirection);
      query.userId = this.props.loginProfile.Id;
      const filterBox = {
        ...this.state.filterBox,
        searchByStatusId: this.state.filterBox.searchByStatusId.map((item) => item.value),
        searchByTradeId: this.state.filterBox.searchByTradeId.map((item) => item.value),
        searchByTierRatingId: this.state.filterBox.searchByTierRatingId.map((item) => item.value),
        searchByCountry: this.state.filterBox.searchByCountry.map((item) => item.value),
        ...(this.state.showInsuranceStatus && { searchByInsuranceStatusId: this.state.filterBox.searchByInsuranceStatusId || '' })
      };
      // add search filters
      query = Utils.addSearchFiltersToQuery(query, filterBox);
      this.addHCId(query);
      // fetch using query
      this.props.actions.fetchSubcontractors(query);
      // save page number
      this.setState({
        filter: {
          pageNumber
        }
      });

    // }
  }

  toggleFilterBox = () => {
    this.setState({ showFilterBox: !this.state.showFilterBox });
  }

  getFetchQuery(userId = this.props.loginProfile.Id, hcId = this.props.hcId) {
    const field = this.state.tableOrderActive;
    const pageNumber = this.state.filter.pageNumber;
    const orderDirection = this.state.order[field] === 'asc' ? 'ASC' : 'DESC';
    let query = Utils.getFetchQuery(field, pageNumber, orderDirection);
    query.userId = userId;
    const filterBox = {
      ...this.state.filterBox,
      searchByStatusId: this.state.filterBox.searchByStatusId.map((item) => item.value),
      searchByTradeId: this.state.filterBox.searchByTradeId.map((item) => item.value),
      searchByTierRatingId: this.state.filterBox.searchByTierRatingId.map((item) => item.value),
      searchByCountry: this.state.filterBox.searchByCountry.map((item) => item.value),
      ...(this.state.showInsuranceStatus && { 
        searchByInsuranceStatusId: Array.isArray(this.state.filterBox.searchByInsuranceStatusId) 
          ? this.state.filterBox.searchByInsuranceStatusId.map((item) => item && item.value ? item.value : '').filter(Boolean).join(',')
          : (this.state.filterBox.searchByInsuranceStatusId && this.state.filterBox.searchByInsuranceStatusId.value ? this.state.filterBox.searchByInsuranceStatusId.value : '') 
      })
    };
    // add search filters
    query = Utils.addSearchFiltersToQuery(query, filterBox);
    query = this.addHCId(query, hcId);
    
    return query;
  }
  submitFilterForm = values => {
    // get base query
    const field = this.state.tableOrderActive;
    const pageNumber = 1;
    const orderDirection = this.state.order[field] === 'asc' ? 'ASC' : 'DESC'
    let query = Utils.getFetchQuery(field, pageNumber, orderDirection);
    query.userId = this.props.loginProfile.Id;
    // add search filters
    const filterBox = {
      searchTerm: values.keywords ? encodeURIComponent(values.keywords) : "",
      searchByHCId: values.associatedHCs || "",
      searchByStatusId: values.status || [],
      searchByTradeId: values.trade || [],
      searchByTierRatingId: values.tierRating || [],
      searchByStateName: values.stateId && values.stateId.value || "",
      searchByCountry: values.countryId || [],
      searchByMaxSingleLimit: values.maxSingle || "",
      searchByMaxAggregateLimit: values.maxAggregate || "",
      searchByVendorId: values.vendorId || "",
      searchByArchive: values.archived || false,
      ...(this.state.showInsuranceStatus && { searchByInsuranceStatusId: values.insuranceStatusId || "" })
    };
    const queryFilterBox = {
      ...filterBox,
      searchByStatusId: filterBox.searchByStatusId.map((item) => item.value),
      searchByTradeId: filterBox.searchByTradeId.map((item) => item.value),
      searchByTierRatingId: filterBox.searchByTierRatingId.map((item) => item.value),
      searchByCountry: filterBox.searchByCountry.map((item) => item.value),
      ...(this.state.showInsuranceStatus && { 
        searchByInsuranceStatusId: Array.isArray(filterBox.searchByInsuranceStatusId) 
          ? filterBox.searchByInsuranceStatusId.map((item) => item && item.value ? item.value : '').filter(Boolean).join(',')
          : (filterBox.searchByInsuranceStatusId && filterBox.searchByInsuranceStatusId.value ? filterBox.searchByInsuranceStatusId.value : '') 
      })
    };
    query = Utils.addSearchFiltersToQuery(query, queryFilterBox);
    query = this.addHCId(query);
    // fetch using query
    this.props.actions.fetchSubcontractors(query);
    // save searchterm and pagenumber
    this.setState({
      filterBox,
      filter: {
        pageNumber: 1
      }
    });
  }

  filtersSaveCallback = (values) => {
    const filterBox = {
      searchTerm: values.keywords || '',
      searchByHCId: values.associatedHCs || '',
      searchByStatusId: values.status
      ? values.status.map((item) => ({
          value: item.value,
          label: item.plainLabel || item.label
        }))
      : [],
      searchByTradeId: values.trade || [],
      searchByTierRatingId: values.tierRating || [],
      searchByStateName: values.stateId && values.stateId.value ? values.stateId.value : '',
      searchByCountry: values.countryId || [],
      searchByMaxSingleLimit: values.maxSingle || '',
      searchByMaxAggregateLimit: values.maxAggregate || '',
      searchByVendorId: values.vendorId || '',
      searchByArchive: values.archived || false,
      ...(this.state.showInsuranceStatus && { 
          searchByInsuranceStatusId: values.insuranceStatusId 
          ? Array.isArray(values.insuranceStatusId) 
            ? values.insuranceStatusId.map((item) => ({ value: item.value, label: item.plainLabel || item.label }))
            : values.insuranceStatusId
          : [] 
      })
    };

    let saveFilter = {
      tab: 'subcontractors',
      module: this.props.fromHCtab ? 'PQHiringclient' : 'hiringclients',
      objectId: null,
      filterBox,
    };

    this.setState({ filterBox });

    this.props.filterActions.saveDefaultFilters('FilterSC', saveFilter)
    .then((result) => {
      const alertOptions = {
        type: result ? 'success' : 'error',
        title: result ? 'Filter saved succesfully!' : 'Error saving filters'
      };

      swal(alertOptions);
    });
  };

  filtersDeleteCallback = () => {
    const newFilterBox = {
      searchTerm: '',
      searchByHCId: '',
      searchByStatusId: [],
      searchByTradeId: [],
      searchByTierRatingId: [],
      searchByStateName: '',
      searchByCountry: [],
      searchByMaxSingleLimit: '',
      searchByMaxAggregateLimit: '',
      searchByVendorId: '',
      searchByArchive: false,
      ...(this.state.showInsuranceStatus && { searchByInsuranceStatusId: '' })
    };

    let saveFilter = {
      tab: 'subcontractors',
      module: this.props.fromHCtab ? 'PQHiringclient' : 'hiringclients',
      objectId: null,
      filterBox: newFilterBox,
    };

    this.props.filterActions.saveDefaultFilters('FilterSC', saveFilter).then((result) => {
      this.setState(
        {
          filterBox: newFilterBox,
          filter: { pageNumber: 1 }
        },
        () => {
          this.props.dispatch(reset('FilterSC'));
          const query = this.getFetchQuery();
          this.props.actions.fetchSubcontractors(query);
        }
      );
      const alertOptions = {
        type: result ? 'success' : 'error',
        title: result ? 'Filters deleted successfully' : 'Error deleting filters',
      };
      swal(alertOptions);
    });
  };

  filtersResetCallback = (event) => {
    event.preventDefault();
    const newFilterBox = {
      searchTerm: '',
      searchByHCId: '',
      searchByStatusId: [],
      searchByTradeId: [],
      searchByTierRatingId: [],
      searchByStateName: '',
      searchByCountry: [],
      searchByMaxSingleLimit: '',
      searchByMaxAggregateLimit: '',
      searchByVendorId: '',
      searchByArchive: false,
      ...(this.state.showInsuranceStatus && { searchByInsuranceStatusId: '' })
    };

    this.setState(
      {
        filterBox: newFilterBox,
        filter: { pageNumber: 1 },
        tableOrderActive: 'id',
        order: {
          id: 'asc',
          name: 'asc',
          mainTrade: 'desc',
          taxID: 'desc',
          tierDesc: 'desc',
          status: 'desc',
          vendorId: 'desc',
          state: 'desc',
          ...(this.state.showInsuranceStatus && { insuranceStatusId: 'desc' })
        }
      },
      () => {
        this.props.dispatch(reset('FilterSC'));
        const query = this.getFetchQuery();
        this.props.actions.fetchSubcontractors(query);
      }
    );
  };

  openAddSCModal = (e) => {
    this.props.actions.setAddSCShowModal(true);
  }

  closeAddSCModal = (e) => {
    this.props.actions.setAddSCShowModal(false);
  }

  getSCTableData() {
    let {
      assignSCUser,
      viewSC,
      tableHeader,
    } = this.props.local.strings.subcontractors;

    const {
      scName,
      tierRating,
      status,
      primaryTrade,
      state
    } = tableHeader;

    const scTableMetadata = {
      fields: [
        'name',
        'status',
        'mainTrade',
        'state',
        'tierDesc',
        'view',
        'assignSCUser',
      ],
      header: {
        name: scName,
        status: status,
        mainTrade: primaryTrade,
        state: state,
        tierDesc: tierRating,
        view: '',
        assignSCUser: ''
      }
    };

    const SCTableBody = this.props.sc.list.map((sc, idx) => {
      if (sc.status === null || sc.status === undefined) sc.status = "None";
      const body = {
        name: sc.name ? Utils.displayQuotes(sc.name) : '',
        status: (
          <span
            className={`status-cell ${(sc.status.toLowerCase()).replace(/\s/g, '')}`}
          >
            {sc.status}
          </span>
        ),
        mainTrade: sc.trade.description,
        state: sc.state,
        tierDesc: `${sc.tier.id} - ${sc.tier.description}`,
        view: (
          <Link
            to={`/subcontractors/${sc.id}`}
            className='cell-table-link icon-quick_view link-ada-color'>
            {viewSC}
          </Link>
        ),

        assignSCUser: (this.renderAssignSCUser())

      };

      return body
    });

    return {
      fields: scTableMetadata.fields,
      header: scTableMetadata.header,
      body: SCTableBody
    };
  }

  getFromHCTabSCTableData() {
    let {
      viewSC,
      tableHeader,
    } = this.props.local.strings.subcontractors;

    const {
      scName,
      tierRating,
      status,
      trade,
      state,
      requestorName,
      requestorEmail
    } = tableHeader;

    const scTableMetadata = {
      fields: [
        'selectedSub',
        'name',
        'tierDesc',
        'status',
        'singleProjectLimit',
        'aggregateProjectExposure',
        'mainTrade',
        'vendorId',
        ...(this.state.showInsuranceStatus ? ['insuranceStatusId'] : []),
        'state',
        'view'
      ],
      header: {
        selectedSub: '',
        name: scName,
        tierDesc: tierRating,
        status: status,
        singleProjectLimit: 'Single Limit',
        aggregateProjectExposure: 'Aggregate Limit',
        mainTrade: trade,
        vendorId: 'Vendor ID',
        ...(this.state.showInsuranceStatus ? { insuranceStatusId: 'Insurance Status' } : {}),
        state: state,
        view: ''
      }
    };

    if (this.state.hcOption == 1) {
      scTableMetadata.fields = [
        'name',
        'tierDesc',
        'status',
        'singleProjectLimit',
        'aggregateProjectExposure',
        'mainTrade',
        'vendorId',
        ...(this.state.showInsuranceStatus ? ['insuranceStatusId'] : []),
        'requestorName',
        'requestorEmail',
        'state',
        'view'
      ]
      scTableMetadata.header.requestorName = requestorName
      scTableMetadata.header.requestorEmail = requestorEmail
    }
    const isAccessToSelect = [SELF_SERVICE_ADMIN_ROLE_ID, PQ_ADMIN_ROLE_ID,PQ_OPERATOR_ROLE_ID,PQ_FINANCIAL_ANALYST_ROLE_ID].includes(this.props.loginProfile.RoleID) ;
    const visibleSelectCheckbox = isAccessToSelect && this.state.filterBox.searchByArchive.toString() === 'false';
    const SCTableBody = this.props.sc.list.map((sc, idx) => {
      if (sc.status === null || sc.status === undefined) sc.status = "None";
      const body = {
        selectedSub: (visibleSelectCheckbox && <input type={'checkbox'} checked={this.props.sc.selectedSubcontractors[sc.id]} onChange={(e) => this.onChangeSelectedSubcontractors(e, sc.id)} />),
        name: sc.name ? Utils.displayQuotes(sc.name) : '',
        tierDesc: `${sc.tier.id} - ${sc.tier.description}`,
        status: (
          <span
            className={`status-cell ${(sc.status.toLowerCase()).replace(/\s/g, '')}`}
          >
            {sc.status}
          </span>
        ),
        singleProjectLimit: (sc.statusId === 6 && sc.singleProjectLimit ? <div style={{ width: '120px'}}>{Utils.formatCurrency(Math.round(sc.singleProjectLimit))}</div> : ""),
        aggregateProjectExposure: (sc.statusId === 6 && sc.aggregateProjectExposure ? <div style={{ width: '120px'}}>{Utils.formatCurrency(Math.round(sc.aggregateProjectExposure))}</div>: ""),
        mainTrade: (
          <div style={{width: '180px', wordWrap: 'break-word'}}>
            {sc.trade.description}
          </div>
        ),
        vendorId: sc.vendorId,
        requestorName: sc.requestorName ? sc.requestorName : '',
        requestorEmail: sc.requestorEmail ? sc.requestorEmail : '',
        state: sc.state,
        view: (
          <a
            onClick={(e) => { this.viewSubcontractor(sc.id) }}
            className='cell-table-link icon-quick_view link-ada-color'>
            {viewSC}
          </a>
        )
      };
      if (this.state.showInsuranceStatus) {
        const insuranceStatusName = sc.insuranceStatusId === PROJECT_INSURED_COMPLIANT_STATUS_ID ? 'Compliant' : sc.insuranceStatusId === PROJECT_INSURED_NON_COMPLIANT_STATUS_ID ? 'Non-Compliant' : false;
        body.insuranceStatusId = (
          <span className={`insurance-status ${insuranceStatusName}`}>
            {insuranceStatusName || ''}
          </span>
        );
      }

      if (this.state.hcOption != 1) {
        delete body.requestorName
        delete body.requestorEmail
      }

      return body
    });

    return {
      fields: scTableMetadata.fields,
      header: scTableMetadata.header,
      body: SCTableBody
    };
  }

  renderAddButonSC() {
    let { addButton } = this.props.local.strings.subcontractors;
    let component = '';

    if (this.props.loginProfile.Role && (this.props.loginProfile.Role.Name != 'Subcontractor')) {
      component = <a
        onClick={this.openAddSCModal}
        className="list-view-nav-link nav-bn icon-add" >
        {addButton}
      </a>
    }

    return component;
  }

  render() {
    let { filterSC } = this.props.local.strings.subcontractors;
    let { totalAmountOfSC, SCPerPage, SCPerPageFromHCTab } = this.props.sc;

    const paginationSettings = {
      total: totalAmountOfSC,
      itemsPerPage: this.props.fromHCtab ? SCPerPageFromHCTab : SCPerPage,
      setPageHandler: async (pageNumber, pageSize) => {
        await this.props.pageSize(pageSize)
        this.setPageFilter('', pageNumber, true)
      },
      currentPageNumber: this.state.filter.pageNumber,
    };
    const selectedSubsCount = Object.keys(this.props.sc.selectedSubcontractors).length
    return (
      <div className="list-view admin-view-body">
        <Modal
          show={this.props.showModal}
          onHide={this.closeAddSCModal}
          className="add-item-modal add-sc"
        >
          <Modal.Body className="add-item-modal-body">
            <AddSCModal close={this.closeAddSCModal} />
          </Modal.Body>
        </Modal>

        <section className="list-view-header">
          <div className="row">
            <div className="col-sm-6">
            </div>
            <div className="col-sm-6">
              <nav className="list-view-nav">
                <ul>
                  {
                    selectedSubsCount > 0 && <li>
                    <a onClick={() => this.archiveSelectedSubcontractors()}
                      className="list-view-nav-link nav-bn" style={{"backgroundColor": 'red'}}>
                      Archive
                    </a>
                  </li>
                  }
                  <li>
                    <a onClick={this.toggleFilterBox}
                      className="list-view-nav-link nav-bn icon-login-door">
                      {filterSC}
                    </a>
                  </li>
                  <li>
                    {this.renderAddButonSC()}
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </section>

        {
          this.state.showFilterBox ?
            <section className="list-view-filters">
              <FilterSC
                onSubmit={this.submitFilterForm}
                fromHCtab={this.props.fromHCtab}
                filtersSaveCallback={this.filtersSaveCallback}
                filtersDeleteCallback={this.filtersDeleteCallback}
                filtersResetCallback={this.filtersResetCallback}
                showInsuranceStatus={this.state.showInsuranceStatus}
              ></FilterSC>
            </section> :
            <div></div>
        }

        <DataTable
          name={`Subcontractors ${ selectedSubsCount > 0 ? "( "+selectedSubsCount+" Selected )":"" }`}
          sorted={true}
          items={this.props.fromHCtab ? this.getFromHCTabSCTableData() : this.getSCTableData()}
          wrapperState={this.state}
          tableOrderActive={this.state.tableOrderActive}
          clickOnColumnHeader={this.clickOnColumnHeader}
          isFetching={this.props.sc.fetchingSC}
          customClass='sc-list'
          pagination={paginationSettings}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { showModal } = state.sc;
  return {
    sc: state.sc,
    hcProfileData: state.HCProfile.profileData,
    local: state.localization,
    loginProfile: state.login.profile,
    showModal
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(scActions, dispatch),
    pageSize: payload => dispatch(scActions.setPageSize(payload)),
    filterActions: bindActionCreators(filterActions, dispatch),
    hcActions: bindActionCreators(hcActions, dispatch),
    registerActions: bindActionCreators(registerActions, dispatch),
    scProfileActions: bindActionCreators(scProfileActions, dispatch),
    setSelectedSubcontractors: selectedSubcontractors => dispatch(scActions.setSelectedSubcontractors(selectedSubcontractors)),
    dispatch,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Subcontractors));
